import API from "@/services/api";
import { EndpointsInvoices } from "./endpoints";
import {
  InvoiceFetchResponse, 
  InvoicesFetchParams 
} from "../types/invoices";

export const fetchInvoices = <TFetch extends InvoicesFetchParams, TType extends TFetch["type"]>({
  filter = '', offset = 0, limit = 100, type
}: TFetch) => {
  return new Promise<InvoiceFetchResponse<TType>>(async (resolve, reject) => {
    API.get<InvoiceFetchResponse<TType>>({
      endpoint: EndpointsInvoices.ElectricityInvoices,
      versions: [2],
      searchParams: [
        '?offset', '=', offset,
        '&limit', '=', limit,
        !!filter.length ? ['&filter', '=', `[${filter}]`].join('') : '',
        '&type', '=', `${type}`,
      ].join(''),
      config: {
        headers: {
          "Content-Type": "application/json"
        }
      }
    })
    .then(res => {
      resolve(res.promise.data);
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  fetchInvoices
};